import React from 'react';
import { Card } from 'react-bootstrap';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the required chart components
ChartJS.register(ArcElement, Tooltip, Legend);

const TaskDistribution = ({ distributionData, title = "Task Distribution" }) => {
  if (!distributionData || !distributionData.labels || !distributionData.data) {
    return (
      <Card className="shadow h-100">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h6 className="m-0 font-weight-bold">{title}</h6>
        </Card.Header>
        <Card.Body className="d-flex align-items-center justify-content-center">
          <p>No distribution data available</p>
        </Card.Body>
      </Card>
    );
  }
  
  // Default colors if not provided
  const defaultColors = [
    '#4e73df', // Primary blue
    '#1cc88a', // Success green
    '#36b9cc', // Info teal
    '#f6c23e', // Warning yellow
    '#e74a3b', // Danger red
    '#6f42c1', // Purple
    '#fd7e14', // Orange
    '#20c9a6', // Turquoise
    '#858796'  // Gray
  ];
  
  const chartData = {
    labels: distributionData.labels,
    datasets: [
      {
        data: distributionData.data,
        backgroundColor: distributionData.colors || defaultColors.slice(0, distributionData.data.length),
        borderColor: distributionData.borderColors || Array(distributionData.data.length).fill('#ffffff'),
        borderWidth: 1,
      },
    ],
  };
  
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 20
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
    cutout: '65%'
  };
  
  return (
    <Card className="shadow h-100">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="m-0 font-weight-bold">{title}</h6>
      </Card.Header>
      <Card.Body>
        <div style={{ height: '300px', position: 'relative' }}>
          <Pie data={chartData} options={options} />
          
          {distributionData.centerText && (
            <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center'
              }}
            >
              <div className="h4 mb-0 font-weight-bold">
                {distributionData.centerText.value}
              </div>
              <div className="small text-gray-500">
                {distributionData.centerText.label}
              </div>
            </div>
          )}
        </div>
        
        {distributionData.description && (
          <div className="mt-4 text-center small">
            <span className="me-2">{distributionData.description}</span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TaskDistribution; 